const basecolors = {
  white: {
    filter: 'grayscale(100%) brightness(0%) invert(100%)'
  },
  dark: {
    filter: 'grayscale(100%) contrast(0%) brightness(35%)'
  },
  grayscale: {
    filter: 'contrast(60%) grayscale(100%)'
  },
  coolGrey: {
    filter: 'contrast(0%) sepia(100%) brightness(85%) hue-rotate(180deg) saturate(20%) brightness(128%)'
  },
  coolGrey70: {
    filter: 'contrast(0%) sepia(100%) brightness(85%) hue-rotate(180deg) saturate(50%) brightness(90%)'
  }
};

const colors = {
  products: {
    chart: basecolors,
    chartblog: basecolors,
    co: basecolors,
    edu: basecolors,
    scale: basecolors,
    spark: basecolors
  }
};

export type colorVariantsType = 'original' | 'white' | 'dark' | 'grayscale' | 'coolGrey' | 'coolGrey70';
export const colorVariants = Object.keys(basecolors) as colorVariantsType[];

export default colors;
